module.exports = __webpack_public_path__ + "51ae96d43761e61847da89f8fd334066.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/IS.svg
// module id = 7NwK
// module chunks = 0